import styled from 'styled-components';
import { Props } from './Status.types'

export const statusBackground: string[] = ['#ffffff', '#003a72', '#7FBA00', '#A6A6A6'];

const Status = styled.div<Props>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 24px;
  width: 128px;
  background-color: ${({ status }) => statusBackground[status]};
  font-size: 12px;
  color: ${({ status }) => (status === 0 ? '#003a72' : '#ffffff')};
  border: ${({ status }) => (status === 0 ? '1px solid #003a72' : 'none')};
`;

export const Styled = {
  Status
};
